import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {

    const {inputProps, onConfirm, onCancel, currentOrder} = props;
    let {type, show, prepareShowCancelModal} = inputProps;
    let title = 'Хотите отменить заказ?';
    let text = 'Если нет откликов или не назначен исполнитель деньги возвращаются и заказ отменяется.';

    let bid_count_text = null;
    
    if(type === 'success') title = 'Заказ успешно отменен!'
    if(type === 'error') title = 'При отмене заказа произошла ошибка!'

    if(type === 'success') text = 'Через несколько секунд вы будете перенаправлены на страницу заказов.';
    if(type === 'error') text = '';

    if(currentOrder.bid_count > 0) {
        title = 'Ошибка!'
        text = `Невозможно отменить заказ, так как на него уже откликнулись исполнители`;
        type = "error";
    }

    return (
        <SweetAlert
            show={show}
            type={type}
            confirmBtnCssClass={`alert-btn-confirm ${prepareShowCancelModal ? 'disabled' : ''}`}
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={type === 'default' ? true : false}
            confirmBtnText="Отменить"
            cancelBtnText="Закрыть"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={title}
            onConfirm={() => prepareShowCancelModal ? false : onConfirm()}
            onCancel={() => onCancel()}
        >
            {
                text
                ?
                <div className="sw-alert__body">{text}</div>
                : null
            }

            {
                prepareShowCancelModal ?
                <div style={{color: '#888', fontSize: '12px', marginTop: '5px'}}>
                    Подождите пожалуйста. Идет проверка на наличие исполнителей
                </div>
                : null
            }
        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/CancelOrder.js